{
  "0_ALREADY_EXISTS": "\"{0}\" 已存在。",
  "0_OF_1": "{0} / {1}",
  "ACCOUNT_ID": "账户 ID",
  "ADD": "添加",
  "ADD_REMOVE_FIELDS": "添加/移除字段",
  "AN_ERROR_OCCURED": "发生错误",
  "APPLY": "应用",
  "APPLY_CHANGES": "应用更改",
  "ATTACH": "附加",
  "ATTACH_AS_LINK": "作为链接附加",
  "ATTACHING": "正在附加...",
  "AUTOMATICALLY_RENAME": "自动重命名",
  "BACK": "返回",
  "BROWSE": "浏览",
  "CANCEL": "取消",
  "CHARACTER_COUNT": "字符数：",
  "CLOSE": "关闭",
  "CLOUD": "Cloud",
  "COMMENT": "评论",
  "CONFIGURE_REPOSITORY_SETTINGS": "配置存储库设置",
  "COULD_NOT_SAVE_0": "无法保存“{0}”。",
  "COULD_NOT_SAVE_0_FILE_TYPE_NOT_SUPPORTED": "无法保存“{0}”。文件类型不受支持。",
  "DATA": "数据",
  "DATE": "日期",
  "DATE_FIELDS_MUST_BE_IN_FORMAT_0": "日期字段必须采用格式 {0}。",
  "DATE_PROVIDED_IS_INVALID": "提供的日期无效。",
  "DATE_TIME": "日期/时间",
  "DATE_TIME_FIELDS_MUST_BE_IN_FORMAT_0": "日期/时间字段必须采用格式 {0}。",
  "DEFAULT_FOLDER": "<默认文件夹>",
  "DETAILS": "详细信息",
  "DO_YOU_WANT_TO_APPLY_YOUR_FIELD_CHANGES": "您要应用字段更改吗？",
  "DOCUMENT_NAME_IS_EMPTY": "文档名称为空",
  "DRAG_DROP_FILE": "拖放文件",
  "ENTRY_0_ALREADY_EXISTS_SELECT_DIFFERENT_NAME": "此文件夹中已存在名为“{0}”的条目。请选择其他名称。",
  "ENTRY_ID": "条目 ID",
  "ENTRY_NAME": "条目名称",
  "ENTRY_NOT_FOUND": "未找到条目。",
  "ERROR_DOWNLOADING_DOCUMENT": "下载文档时出错。",
  "ERROR_OCCURRED_WHILE_CONNECTING_TO_SERVER": "连接服务器时发生错误。",
  "ERROR_SAVING": "保存错误：",
  "FAILED_TO_OPEN_FOLDER": "打开文件夹失败",
  "FAILED_TO_SAVE_COLON": "保存失败：",
  "FAILED_TO_SAVE_PERIOD": "保存失败。",
  "FEEDBACK": "反馈",
  "FIELDS": "字段",
  "FILE_EXCEEDS_MAXIMUM_FILE_SIZE_25MB": "此文件超过最大文件大小 25MB。",
  "FILE_EXTENSION": "文件扩展名",
  "FILE_LOCKED": "文件已锁定。",
  "FILE_MODIFIED": "文件已修改",
  "FILE_NAME": "文件名",
  "FILENAMES_CANNOT_CONTAIN_BACKSLASH": "文件名不能包含反斜杠",
  "FOLDER": "文件夹",
  "INTEGER": "整数",
  "LIST": "列表",
  "LOADING": "加载中...",
  "LONG_FIELDS_MUST_BE_INTEGERS_BETWEEN_0_3999999999": "长字段必须是介于 0 到 3,999,999,999 之间的整数",
  "LONG_INTEGER": "长整数",
  "NAME": "名称",
  "NAME_CONFLICT": "名称冲突",
  "NEED_HELP_SIGNING_IN_CONTACT_LASERFICHE_ADMINISTRATOR_FOR_HELP": "需要登录帮助？请联系您的 Laserfiche 管理员。",
  "NEW_FOLDER": "新建文件夹",
  "NO": "否",
  "NO_ADDITIONAL_FIELDS_ASSIGNED": "未分配其他字段",
  "NO_FOLDER_SELECTED": "未选择文件夹。",
  "NO_MATCHING_ENTRIES_FOUND": "未找到匹配的条目",
  "NO_MATCHING_FIELDS_FOUND": "未找到匹配的字段。",
  "NO_TEMPLATE_ASSIGNED": "未分配模板",
  "NOT_AVAILABLE_WITH_TOKENS": "令牌不可用",
  "NUMBER": "编号",
  "NUMBER_FIELD_MUST_BE_VALID_NUMBER": "数字字段必须是有效数字",
  "OK": "确定",
  "ONE_OR_MORE_FIELDS_INVALID": "一个或多个字段无效。",
  "OPEN": "打开",
  "OPEN_IN_LASERFICHE": "在 Laserfiche 中打开",
  "OPTIONAL": "可选",
  "OR": "或",
  "PARENT_FIELD": "父字段",
  "PARENT_ID": "父 ID",
  "PARENT_NAME": "父名称",
  "PLEASE_SELECT_A_FOLDER": "请选择一个文件夹",
  "REASON_FOR_DOWNLOADING": "下载原因",
  "REFRESH": "刷新",
  "REMOVE": "移除",
  "REMOVE_REPOSITORY": "移除存储库？",
  "REPOSITORY": "Laserfiche Repository",
  "REPOSITORY_COUNT": "存储库计数",
  "REPOSITORY_ID": "存储库 ID",
  "REPOSITORY_NAME": "存储库名称",
  "REQUIRED": "必填",
  "REQUIRED_FIELD_IS_EMPTY": "必填字段为空",
  "SAVE_CHANGES": "保存更改",
  "SAVE_TO_LASERFICHE": "保存到 Laserfiche",
  "SAVED_TO_LASERFICHE": "已保存到 Laserfiche",
  "SAVED_TO_LASERFICHE_COLON": "已保存到 Laserfiche：",
  "SAVED_WITH_MISSING_METADATA": "保存时缺少元数据：",
  "SAVING": "保存中...",
  "SEARCH_FIELDS": "搜索字段",
  "SELECT": "选择",
  "SELECT_REASON": "选择原因",
  "SELF_HOSTED": "自托管",
  "SESSION_COUNT": "会话计数",
  "SETTINGS": "设置",
  "SHORT_FIELDS_MUST_BE_INTEGERS_BETWEEN_0_64999": "短字段必须是介于 0 到 64999 之间的整数",
  "SIGN_IN": "登录",
  "SIGN_IN_TO_LASERFICHE": "登录 Laserfiche",
  "SIGN_OUT": "注销",
  "SIGNING_IN": "正在登录...",
  "SIGNING_OUT": "正在注销...",
  "SKIP_THIS_FILE": "跳过此文件",
  "SOMETHING_WENT_WRONG_PLEASE_TRY_AGAIN_LATER": "出现问题。请稍后再试。",
  "SUBMIT": "提交",
  "SUGGESTION": "建议",
  "TEMPLATE": "模板",
  "TEMPLATE_HAS_FAILED_TO_LOAD": "模板加载失败。",
  "TEXT": "文本",
  "THANK_YOU_FOR_SUBMISSION": "感谢您的提交！",
  "THIS_FIELD_HAS_MAXIMUM_ALLOWED_LENGTH_0_CHARACTERS": "此字段的最大允许长度为 {0} 个字符。",
  "THIS_FOLDER_IS_EMPTY": "此文件夹为空。",
  "TIME": "时间",
  "TIME_FIELDS_MUST_BE_IN_FORMAT_0": "时间字段必须采用格式 {0}。",
  "UNABLE_TO_LOAD_ALL_FIELDS": "无法加载所有字段：",
  "UNABLE_TO_RETRIEVE_REPOSITORY_INFORMATION": "无法检索存储库信息：",
  "UNKNOWN_ERROR": "未知错误。",
  "USER_NAME": "用户名",
  "YES": "是"
}
